import cx from "classnames";
import { Form, Formik } from "formik";

import { Button, Col, Divider, Modal, Row, Space } from "antd";
import { Input, Select } from "components/form";
import { useTranslation } from "react-i18next";

import schema from "../../../features/company/schemas/companyPositionSchema";
import styles from "./Modal.module.css";
import { useSelector } from "react-redux";
import { state } from "@antv/g2plot/lib/adaptor/common";

function ModalCreatePosition({
  node = {},
  title = "",
  width = 975,
  className = "",
  back = "CANCEL",
  submit = "SAVE",
  blankForm = false,
  isModalOpen = false,
  modifiedPositionOptions = [],
  onSubmit = () => { },
  handleOk = () => { },
  handleCancel = () => { },
}) {
  const onCancel = () => {
    const cancelBtn = document.getElementById("organization__cancelBtn");
    if (cancelBtn) {
      cancelBtn.click();
    } else {
      handleCancel();
    }
  };

  const { t } = useTranslation();
  const roles = useSelector((state) => state.company.roles)
  const positionCreate = roles.includes("CREATE_CONFIGURATION|COMPANY_SETTING|POSITION");
  const positionEdit = roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|POSITION");

  const shouldDisableField = () => {
    if (submit.toUpperCase() === 'CREATE') {
      return !positionCreate;
    } else {
      return positionCreate && !positionEdit;
    }
  };

  return (
    <Modal
      destroyOnClose
      title={title}
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className={cx(styles.customStyle, className)}
      width={width}
      footer={null}
      closable={false}
      maskClosable={false}
    >
      <Formik
        enableReinitialize
        initialValues={{
          positionName: blankForm ? null : node.positionName,
          positionNameEn: blankForm ? null : node.positionNameEn,
          jobDescription: blankForm ? null : node.jobDescription,
          jobSpecification: blankForm ? null : node.jobSpecification,
          under: title == "Create" || title == "สร้างใหม่" ? node.positionId : (node.under || {}).id,
          level: node?.level
        }}
        validationSchema={schema}
        onSubmit={(values) => {

          const obj = {
            positionId: node.positionId,
            ...values,
          };
          onSubmit(obj, handleCancel);
        }}
      >
        {({ resetForm = () => { } }) => {
          return (
            <Form>
              <Space
                className={styles.container}
                size={24}
                direction="vertical"
              >
                <Divider />
                <Row gutter={[24, 10]}>
                  <Col span={12}>
                    <Input
                      name="positionName"
                      label={
                        t("position.label.name_th")
                      }
                      placeholder={t('position-name-th')}
                      size="large"
                      required
                      disabled={shouldDisableField()}
                    />
                  </Col>
                  <Col span={12}>
                    <Input
                      name="positionNameEn"
                      label={
                        t("position.label.name_en")
                      }
                      placeholder={t('position-name-en')}
                      size="large"
                      required
                      disabled={shouldDisableField()}
                    />
                  </Col>
                  <Col span={12}>
                    <Input
                      name="jobDescription"
                      label={t("position.label.job_description")}
                      placeholder={t("position.label.job_description")}
                      size="large"
                      type="textarea"
                      disabled={shouldDisableField()}
                    />
                  </Col>
                  <Col span={12}>
                    <Input
                      name="jobSpecification"
                      label={t("position.label.job_specification")}
                      placeholder={t("position.label.job_specification")}
                      size="large"
                      type="textarea"
                      disabled={shouldDisableField()}
                    />
                  </Col>
                  <Col span={12}>
                    <Select
                      name="under"
                      label={t("position.label.under")}
                      placeholder={t("position.label.under")}
                      size="large"
                      options={modifiedPositionOptions}
                      disabled={shouldDisableField()}
                    />
                  </Col>
                  <Col span={12}></Col>
                </Row>
                <Row justify="end">
                  <Space direction="horizontal" size={12}>
                    <Button
                      id="position__cancelBtn"
                      key="back"
                      onClick={() => {
                        handleCancel();
                        resetForm();
                      }}
                      type="default"
                      style={{ height: "40px", borderRadius: "8px" }}
                    >
                      {t("common.cancel")}
                    </Button>
                    {(!shouldDisableField()) &&
                      <Button
                        htmlType="submit"
                        type="primary"
                        style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}
                      >
                        {t("common.submit")}
                      </Button>}
                  </Space>
                </Row>
              </Space>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
}

export default ModalCreatePosition;
